import React from 'react';
import { FeedItemDetailContent } from './FeedItemDetailsContent';
import SearchNavBar from '../search/SearchNavBar';
import IntegratedSearchNavBar from '../navigation/IntegratedSearchNavBar';

const MobileBottomNav = () => (
  <div style={{ height: '100px' }}>
    <nav className="navbar fixed-bottom" id="navbarMobileBottom">
      <div id="changeBranchDropdownMobile" />
    </nav>
  </div>
);

const getCountryFromSchema = (schema) => {
  if (schema?.includes('canada') || schema?.includes('ca_')) return 'ca';
  if (schema?.includes('mexico') || schema?.includes('mx_')) return 'mx';
  if (schema?.includes('uk_')) return 'uk';
  return 'us';
};

const FeedItemDetailLayout = ({
  schema,
  table,
  item,
  allVotes,
  membersData,
  loading,
  loadingMembers,
  error,
  onBack,
  buttonName
}) => {
  const country = getCountryFromSchema(schema);

  const renderBody = () => {
    if (loading) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="alert alert-danger m-3" role="alert">
          <strong>Error:</strong> {error}
        </div>
      );
    }

    return (
      <FeedItemDetailContent
        item={item}
        allVotes={allVotes}
        membersData={membersData}
        loadingMembers={loadingMembers}
        table={table}
        schema={schema}
        onBack={onBack}
        buttonName={buttonName}
      />
    );
  };

  return (
    <>
      {/* <SearchNavBar pageCurrentCountry={country} /> */}
      <IntegratedSearchNavBar/>
      <div id="homebg">
  
        {renderBody()}
      </div>
    </>
  );
};

export default FeedItemDetailLayout;